/**
 * Shared route metadata for the tenant shell. Kept here (not inline in Layout)
 * so the shell reads declarative route patterns instead of hand-rolled pathname
 * logic. Patterns are matched with react-router's own `matchPath`.
 *
 * Full-bleed routes render edge-to-edge (they own their viewport height and,
 * for the inbox, a master-detail width); every other route sits in a centered
 * column. Keep these patterns in sync with the route paths in App.tsx.
 */
export const INBOX_PATH = '/inbox';

/**
 * App-shell routes: the page is exactly the visible viewport (no document scroll); the header, any banner and the
 * page padding are laid out inside it and the workspace fills the rest, its panes scrolling internally. Other routes
 * scroll as documents.
 */
export const APP_SHELL_ROUTES = [
  INBOX_PATH,
  '/tickets/:id',
];

export const FULL_BLEED_ROUTES = [
  INBOX_PATH,                // canonical inbox workspace
  '/tickets/:id',            // inbox master-detail (ticket open)
  '/analytics',              // wide, data-dense analytics workspace
  '/paused',                 // wide, searchable customer operations workspace
  '/team',                   // wide team-management table and assignment controls
];
